import PropTypes from 'prop-types';
import React from 'react';
import styles from './SubmitButton.scss';
import { Loader } from '.';
import classnames from 'classnames';

const noop = () => {};

const SubmitButton = (
  {
    onClick = noop,
    label,
    pending,
    style = null,
    disabled,
    className = '',
  } = {}
) => {
  const buttonClassName = classnames(
    styles.submitButton,
    {
      [styles.submitButtonDisabled]: disabled === true,
    },
    className
  );
  return (
    <button
      className={buttonClassName}
      onClick={pending ? noop : onClick}
      type="button"
      style={style}
      disabled={disabled}
    >
      {pending ? <Loader size="1.5em" thickness="0.15em" /> : label}
    </button>
  );
};

// TODO muted button

SubmitButton.propTypes = {
  onClick: PropTypes.func,
  pending: PropTypes.bool,
  label: PropTypes.string.isRequired,
  style: PropTypes.object,
  disabled: PropTypes.bool,
};

SubmitButton.defaultProps = {
  disabled: false,
};

export default SubmitButton;



// WEBPACK FOOTER //
// ./src/components/Common/SubmitButton.js